import { render, staticRenderFns } from "./IdPromptModal.vue?vue&type=template&id=10ef8e50&scoped=true&"
import script from "./IdPromptModal.vue?vue&type=script&lang=ts&"
export * from "./IdPromptModal.vue?vue&type=script&lang=ts&"
import style0 from "./IdPromptModal.vue?vue&type=style&index=0&id=10ef8e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef8e50",
  null
  
)

export default component.exports